module.exports = __webpack_public_path__ + "img/hr-level1_mining_tool-1.b1e6e017.png";